export var QueryType;
(function (QueryType) {
    QueryType["VISUAL"] = "visual";
    QueryType["PROPERTY"] = "property";
})(QueryType || (QueryType = {}));
export var ArticlePresentationFormat;
(function (ArticlePresentationFormat) {
    ArticlePresentationFormat["AdviceHub"] = "AdviceHub";
    ArticlePresentationFormat["AdvicePage"] = "AdvicePage";
    ArticlePresentationFormat["BrandedPage"] = "BrandedPage";
    ArticlePresentationFormat["CorporatePage"] = "CorporatePage";
    ArticlePresentationFormat["FilterPresentation"] = "FilterPresentation";
    ArticlePresentationFormat["GenericPage"] = "GenericPage";
    ArticlePresentationFormat["HomepagePresentation"] = "HomepagePresentation";
    ArticlePresentationFormat["StorePage"] = "StorePage";
    ArticlePresentationFormat["Top10Presentation"] = "Top10Presentation";
    ArticlePresentationFormat["VisualPresentation"] = "VisualPresentation";
})(ArticlePresentationFormat || (ArticlePresentationFormat = {}));
export var CoolbluesChoiceType;
(function (CoolbluesChoiceType) {
    CoolbluesChoiceType["Green"] = "Green";
    CoolbluesChoiceType["Normal"] = "Normal";
})(CoolbluesChoiceType || (CoolbluesChoiceType = {}));
export var VideoType;
(function (VideoType) {
    VideoType["YOUTUBE"] = "Youtube";
    VideoType["IMAGE"] = "Image";
})(VideoType || (VideoType = {}));
export var ImageOriginCollectionName;
(function (ImageOriginCollectionName) {
    ImageOriginCollectionName[ImageOriginCollectionName["Content"] = 0] = "Content";
    ImageOriginCollectionName[ImageOriginCollectionName["Products"] = 1] = "Products";
    ImageOriginCollectionName[ImageOriginCollectionName["Reviews"] = 2] = "Reviews";
    ImageOriginCollectionName[ImageOriginCollectionName["SecondChance"] = 3] = "SecondChance";
    ImageOriginCollectionName[ImageOriginCollectionName["Temp"] = 4] = "Temp";
    ImageOriginCollectionName[ImageOriginCollectionName["DeliveryInstallation"] = 5] = "DeliveryInstallation";
    ImageOriginCollectionName[ImageOriginCollectionName["Animations"] = 6] = "Animations";
})(ImageOriginCollectionName || (ImageOriginCollectionName = {}));
export var AvailabilityState;
(function (AvailabilityState) {
    AvailabilityState["AvailableSoon"] = "AvailableSoon";
    AvailabilityState["OnStock"] = "OnStock";
    AvailabilityState["TemporaryOutOfStock"] = "TemporaryOutOfStock";
    AvailabilityState["OutOfStock"] = "OutOfStock";
    AvailabilityState["Historic"] = "Historic";
    AvailabilityState["PreOrder"] = "PreOrder";
})(AvailabilityState || (AvailabilityState = {}));
export var CallToActionType;
(function (CallToActionType) {
    CallToActionType["NoCta"] = "NoCta";
    CallToActionType["Regular"] = "Regular";
    CallToActionType["Primary"] = "Primary";
    CallToActionType["Secondary"] = "Secondary";
    CallToActionType["DownloadApp"] = "DownloadApp";
})(CallToActionType || (CallToActionType = {}));
export var HemingwayLinkType;
(function (HemingwayLinkType) {
    HemingwayLinkType["External"] = "HemingwayExternalLinkV3";
    HemingwayLinkType["Internal"] = "HemingwayInternalLinkV3";
    HemingwayLinkType["Sitemap"] = "HemingwaySitemapLinkV3";
    HemingwayLinkType["DownloadApp"] = "HemingwayDownloadAppLinkV3";
    HemingwayLinkType["ProductId"] = "HemingwayProductIdLinkV3";
})(HemingwayLinkType || (HemingwayLinkType = {}));
export var EntranceDisplay;
(function (EntranceDisplay) {
    EntranceDisplay["Default"] = "Default";
    EntranceDisplay["Emphasised"] = "Emphasised";
    EntranceDisplay["WithDescription"] = "WithDescription";
    EntranceDisplay["WithProCon"] = "WithProCon";
    EntranceDisplay["Pill"] = "Pill";
})(EntranceDisplay || (EntranceDisplay = {}));
export var HomepageBannerSlotName;
(function (HomepageBannerSlotName) {
    HomepageBannerSlotName["PrimaryBanner1A"] = "Leaderboard1A";
    HomepageBannerSlotName["PrimaryBanner1B"] = "Leaderboard1B";
    HomepageBannerSlotName["SecondaryBanner1"] = "Leaderboard2";
    HomepageBannerSlotName["SecondaryBanner2"] = "Leaderboard3";
    HomepageBannerSlotName["SecondaryBanner3"] = "Leaderboard4";
    HomepageBannerSlotName["TertiaryBanner1"] = "Leaderboard5";
    HomepageBannerSlotName["TertiaryBanner2"] = "Leaderboard6";
    HomepageBannerSlotName["TertiaryBanner3"] = "Leaderboard7";
    HomepageBannerSlotName["CorporateBanner1"] = "CorporateBanner1";
    HomepageBannerSlotName["CorporateBanner2"] = "CorporateBanner2";
})(HomepageBannerSlotName || (HomepageBannerSlotName = {}));
//# sourceMappingURL=types.js.map